<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/5chap1#chap1">I. The End of an Affair</a></p>
<p class="toc1"><a href="#/6chap2#chap2">II. A Patient’s Subsconscious</a></p>
<p class="toc1"><a href="#/7chap3#chap3">III. “I Understand Him too Well!”</a></p>
<p class="toc1"><span href="#/8chap4#chap4" title="Link target outside of Sample">IV. “If He Dies—”</span></p>
<p class="toc1"><span href="#/9chap5#chap5" title="Link target outside of Sample">V. Is a Woman Surgeon Still a Woman?</span></p>
<p class="toc1"><span href="#/10chap6#chap6" title="Link target outside of Sample">VI. No Longer Her Patient</span></p>
<p class="toc1"><span href="#/11chap7#chap7" title="Link target outside of Sample">VII. A Hospital Christmas—and a Kiss</span></p>
<p class="toc1"><span href="#/12chap8#chap8" title="Link target outside of Sample">VIII. In the Doctor’s Room</span></p>
<p class="toc1"><span href="#/13chap9#chap9" title="Link target outside of Sample">IX. A Part in a Play</span></p>
<p class="toc1"><span href="#/14chap10#chap10" title="Link target outside of Sample">X. Lifted Out of Hell</span></p>
<p class="toc1"><span href="#/15chap11#chap11" title="Link target outside of Sample">XI. Betrayed to the Darkness</span></p>
<p class="toc1"><span href="#/16chap12#chap12" title="Link target outside of Sample">XII. Night and the First Beloved</span></p>
<p class="toc1"><span href="#/17chap13#chap13" title="Link target outside of Sample">XIII. Clandestine Romance</span></p>
<p class="toc1"><span href="#/18chap14#chap14" title="Link target outside of Sample">XIV. There’s No Substitute for Living</span></p>
<p class="toc1"><span href="#/19chap15#chap15" title="Link target outside of Sample">XV. A Shattering Experience</span></p>
<p class="toc1"><span href="#/20chap16#chap16" title="Link target outside of Sample">XVI. A Night to Remember</span></p>
<p class="toc1"><span href="#/21chap17#chap17" title="Link target outside of Sample">XVII. Village Gossip</span></p>
<p class="toc1"><span href="#/22chap18#chap18" title="Link target outside of Sample">XVIII. A Long-Kept Secret</span></p>
<p class="toc1"><span href="#/23chap19#chap19" title="Link target outside of Sample">XIX. Into the Light</span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/24biography#biography" title="Link target outside of Sample">A Biography of Mary Renault</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3TOC.vue?f3165ab6